import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppSettingsContextProvider } from '~/AppSettingsContext';
import { IdentityContextProvider } from '~/features/authentication/identity/IdentityContext';
import { SuspenseWrapper } from '~/shared/SuspenseWrapper';

/**
 * Layout element for the authenticated route subtree. The auth gate and
 * redirect-to-login live in secureRouteLoader, which runs before this renders —
 * so by the time we get here the user is guaranteed authenticated and resolved.
 *
 * AppSettingsContextProvider is mounted here (rather than globally) so it only
 * exists for loader-gated routes where the logged-in user is available. This keeps
 * a single auth source: the loader. Transient routes (/login/callback, /logout)
 * render without it and therefore never call useAppSettings/userIsAnAdmin.
 */
export function SecureRoute() {
	return (
		<SuspenseWrapper name="AppSettingsProvider">
			<IdentityContextProvider>
				<AppSettingsContextProvider>
					<Outlet />
				</AppSettingsContextProvider>
			</IdentityContextProvider>
		</SuspenseWrapper>
	);
}
